import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FaGraduationCap } from 'react-icons/fa'

const educationDetails = [
  {
    id: 1,
    degree: 'Bachelor of Science in Computer Science',
    cgpa: 'CGPA 3.58/4.0',
    achievements: [
      'Silver Medalist, Batch 09 (CS)',
      'Group Leader for multiple academic projects',
      'Member, BSCS Society (2014)',
      'Conducted workshops on Web Development (ASP.NET)',
      'Led workshops on Windows 8 app development',
    ],
    flip: 'flip-left',
  },
]

export default function Education() {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  return (
    <section
      id="education"
      className=" px-6 sm:px-12 lg:px-20 flex flex-col items-center justify-center"
    >
      <h2 className="text-lg leading-7 text-center">My Education</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl text-center">
       My Academic Journey
      </p>

      {/* Centered Card with Left-Aligned Text */}
      <div className="mt-10 flex justify-center w-full">
        {educationDetails.map((edu) => (
          <div
            key={edu.id}
            className="w-full max-w-3xl group relative ring-2 ring-base-300 bg-base-200 rounded-2xl shadow-xl p-8 text-left"
            data-aos={edu.flip}
          >
            <div className="flex items-center gap-6">
              <FaGraduationCap className="text-5xl text-blue-500" />
              <div>
                <h3 className="text-2xl font-bold text-base-content">
                  {edu.degree}
                </h3>
                <p className="text-md text-gray-500">{edu.cgpa}</p>
              </div>
            </div>
            <ul className="mt-5 text-lg text-gray-600 list-disc pl-6 space-y-3">
              {edu.achievements.map((achievement, index) => (
                <li key={index}>{achievement}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}
